import { render } from "./Before.vue?vue&type=template&id=2b79e3bc&scoped=true"
import script from "./Before.vue?vue&type=script&lang=js"
export * from "./Before.vue?vue&type=script&lang=js"

import "./Before.vue?vue&type=style&index=0&id=2b79e3bc&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b79e3bc"]])

export default __exports__